import request from '@/utils/request'

/**
 * 获取广告信息
 * @param data
 */
export const getAdvertising = (data) => {
  return request({
    url: `/sol/wap/ad_servings/position/${data}`,
    method: 'get'
  })
}

/**
 * 获取品牌数据
 * @param data
 */
export const getBrands = (data) => {
  return request({
    url: '/sol/brands',
    method: 'get',
    params: data
  })
}

/**
 * 获取所有品牌数据
 * @param data
 */
export const getAllBrandOwner = () => {
  return request({
    url: '/sol/brands/wapQueryAllBrandOwner',
    method: 'get',
  })
}

/**
 * 获取公共数据
 * 1:企业类型 ,2业务类型,3专业领域,4服务区域,5一级系统属性,6建筑业态,7二级系统属性,8 品牌分类
 * @param data
 */
export const getCommonData = (data) => {
  return request({
    url: '/sol/common_data',
    method: 'get',
    params: data
  })
}

/**
 * 获取用户信息
 */
export const queryUserInfo = () => {
  return request({
    url: '/platformApi/Account/GetLoginUserInfo?callback=',
    method: 'get'
  })
}

export const upDataUserInfo = (data) => {
  return request({
    url: '/sol/wap/user',
    method: 'put',
    data: data
  })
}

/**
 * 获取风讯配置
 */
export const getCMSData = () => {
  return request({
    url: process.env.GET_CMS_CONFIG_URL,
    method: 'get'
  })
}

/**
 * 阿里云签名获取
 */
 export function getOssSignReq() {
  return request({
    url: '/oss/sign/wuyou-resource/shanghai/Solution',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/common.js